import { ConfigClientType } from '../types/ConfigClientType';

const hideChatFromPages = ['/mina-skador', '/mine-skader', '/omat-vahingot', '/skader'];

const showChatButton = (iimclient: ConfigClientType) => {
    if (iimclient.hideChatBox) return false;
    const currentPage = window.location.href || '';
    if (hideChatFromPages.find((page) => currentPage.includes(page))) return false;
    return !!(
        !iimclient.segment ||
        (iimclient.segment &&
            iimclient.segment.chatqueue &&
            iimclient.segment.floater_chatisvisible) ||
        (iimclient.segment && iimclient.segment.chatqueue && iimclient.testURLMapping)
    );
};

const showCallButton = (iimclient: ConfigClientType) => {
    if (iimclient.hidePhoneBox) return false;
    return !!(
        !iimclient.segment ||
        (iimclient.segment.floater_phoneisvisible && !iimclient.segment.url_hide_phone_icon) ||
        iimclient.testURLMapping
    );
};

const showEmailButton = (iimclient: ConfigClientType) => {
    if (iimclient.hideEmailBox) return false;
    return !!(
        !iimclient.segment ||
        (iimclient.segment && iimclient.segment.floater_emailisvisible) ||
        iimclient.testURLMapping
    );
};

export { showChatButton, showCallButton, showEmailButton };
